//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
  data () {
    return {
      tabIndex: '0',
      tabIndex1: '0',
      resourceTabIndex: '0',
      xhsInspirationContent: [
        {
          xhsNumber: '1',
          xhsText: '筛选高质高 权重账号'
        },
        {
          xhsNumber: '2',
          xhsText: '把控内容设 置关键字'
        },
        {
          xhsNumber: '3',
          xhsText: '网红联动霸 屏策略'
        },
        {
          xhsNumber: '4',
          xhsText: '精通推荐 机制'
        }
      ],
      resourceFood: [],
      resourceBeauty: [],
      resourceMother: [],
      resourceFashion: []
    }
  },
  methods: {
    changeTabContent (index) {
      this.tabIndex = index
    },
    changeResourceTab (index) {
      this.resourceTabIndex = index
    },
    //  客户案例的切换
    changeTab (index) {
      this.tabIndex1 = index
    }
  },
  filters: {
    formatNumInTenThousand: function (value) {
      const num = parseInt(value)
      const num2 = num / 10000
      if (num2 >= 1) {
        return Math.round(num2 * 100) / 100 + '万'
      } else {
        return num
      }
    }
  },
  mounted () {
    this.handleDoubleData()
  },
  components: {
    IndexHeader,
    IndexSidebar,
    IndexFooter
  }
}



// WEBPACK FOOTER //
// ./src/pages/promotionXhs/index.vue